import dayjs from "dayjs";
import { Fund } from "types/types";

export const getMaximumAvailableReportingPeriod = (inceptionDate: string) => {
  return dayjs().startOf("month").diff(dayjs(inceptionDate), "years");
};

export const getLimitingFund = (selectedFunds: Fund[]) =>
  selectedFunds.length
    ? selectedFunds.reduce((accumulator, fund) =>
        accumulator.availableReportingPeriod < fund.availableReportingPeriod
          ? accumulator
          : fund,
      )
    : undefined;

export const getCustomStartDateBounds = (selectedFunds: Fund[]) => {
  const limitingFund = getLimitingFund(selectedFunds);

  const endDate = dayjs().startOf("month").subtract(1, "day");
  const maxStartDate = endDate.subtract(1, "year").format("YYYY-MM-DD");
  const minStartDate = limitingFund
    ? dayjs(limitingFund.inceptionDate).format("YYYY-MM-DD")
    : endDate.format("YYYY-MM-DD");

  return { minStartDate, maxStartDate, endDate: endDate.format("YYYY-MM-DD") };
};

export const isCustomStartDateValid = (
  customStartDate: string | undefined,
  minStartDate: string,
  maxStartDate: string,
) =>
  !!customStartDate &&
  customStartDate >= minStartDate &&
  customStartDate <= maxStartDate;

export const getReportingPeriod = (
  years?: number,
  customStartDate?: string,
) => {
  const startOfCurrentMonth = dayjs().startOf("month");
  const endDate = startOfCurrentMonth.subtract(1, "days").format("YYYY-MM-DD");
  const startDate = customStartDate
    ? dayjs(customStartDate).format("YYYY-MM-DD")
    : startOfCurrentMonth.subtract(years ?? 0, "years").format("YYYY-MM-DD");
  return { startDate, endDate };
};
